import React from 'react'
import AppRouter from './routers/AppRouter'

const App: React.FC = () => {
  return (
    <AppRouter />
  )
}

export default App
